import React from 'react';
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import AccordionUsage from "../../Components/Poi/Accordin";
import Slider from "../../Components/Poi/Slider";
import Description from "../../Components/Poi/Description";
import Boxes from "../../Components/Shimmer/Boxes";
import LatestBlogs from '../../Components/LatestBlogs';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
function Poi({ initialData = {}, language }) {
  const [lang, setLang] = useState(language);
  const { url: paramUrl } = useParams();
  const poiId = paramUrl.split("-").pop();
  const location = useLocation();
  const [poi, setPoi] = useState(initialData.poi?.data || {});
  const [images, setImages] = useState(initialData.poi?.data?.images || []);
  const [load, setLoad] = useState(!!initialData.poi?.data);
  const [currency, setCurrency] = useState(initialData.currency?.data || []);
  const [notFound, setNotFound] = useState(false);
 const navigate =useNavigate()
    function truncateText(text, wordLimit) {
    if (!text) return "";
    const words = text?.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  }
  const categoryId = "all"
   const handelExploreMore = () => {
    navigate(`/${language}/all-poi/${categoryId}`); window.scrollTo({
      top: 0,
      behavior: 'smooth', // This adds a smooth scroll effect
    })
  };
  useEffect(() => {
    const fetchData = async () => {
      if (!initialData.poi || !initialData.currency) {
        try {
          const [poiRes, currencyRes] = await Promise.all([
            axios.get(`https://admin.hopdays.com/api/single-poi/${poiId}?language=${lang || "en"}`),
            axios.get(`https://admin.hopdays.com/api/currency/all`)
          ]);

          if (poiRes?.data?.data) {
            setPoi(poiRes.data.data);
            setImages(poiRes.data.data.images);
            setLoad(true);
          }
          setCurrency(currencyRes.data.data);
        } catch (error) {
          console.error("Error fetching data:", error);
          setNotFound(error.response?.status === 404);
          setLoad(true);
        }
      }
    };
    fetchData();
  }, [poiId, initialData, lang]);

  if (!load) {
    return (
      <div className="text-center py-20 text-xl font-medium">
        <Boxes />
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="text-center py-20 text-xl font-medium">
        Content not available in the selected language.
      </div>
    );
  }

  const renderLocationLinks = () => {
    const citySlug = poi?.cityData?.slug?.toLowerCase().replace(/\s+/g, "-") || "";
    const stateSlug = poi?.stateData?.slug?.toLowerCase().replace(/\s+/g, "-") || "";
    const countryName = poi?.countryData?.name?.toLowerCase().replace(/\s+/g, "-") || "";
    const countrySlug = poi?.countryData?.slug?.toLowerCase().replace(/\s+/g, "-") || "";

    return (
      <p className="mt-4 max-sm:mt-2 text-[20px] max-sm:text-[16px] font-light">
        {lang === "ar" ? (
          <>
            <Link
              to={`/ar/trip/${citySlug}-tourism-${countryName}-${poi.cityData?._id}-ctytsmid`}
              className="text-blue-500 hover:underline"
            >
              {poi.cityData?.ar_name}
            </Link>
            ,{" "}
            <Link
              to={`/ar/travel/${stateSlug}-tourism-${countryName}-${poi.stateData?._id}-sttsmid`}
              className="text-blue-500 hover:underline"
            >
              {poi.stateData?.ar_name}
            </Link>
 ,{" "}
            <Link
              to={`/ar/visit/${countrySlug}-tourism-${countryName}-${poi.countryData?._id}-cnttsmid`}
              className="text-blue-500 hover:underline"
            >
              {poi.countryData?.ar_name}
            </Link>
            {/* , {poi.countryData?.ar_name} */}
          </>
        ) : (
          <>
            <Link
              to={`/en/trip/${citySlug}-tourism-${countryName}-${poi.cityData?._id}-ctytsmid`}
              className="text-blue-500 hover:underline"
            >
              {poi.cityData?.name}
            </Link>
            ,{" "}
            <Link
              to={`/en/travel/${stateSlug}-tourism-${countryName}-${poi.stateData?._id}-sttsmid`}
              className="text-blue-500 hover:underline"
            >
              {poi.stateData?.name}
            </Link>
            , {" "}
             <Link
              to={`/en/visit/${countrySlug}-tourism-${countryName}-${poi.countryData?._id}-cnttsmid`}
              className="text-blue-500 hover:underline"
            >
              {poi.countryData?.name}
            </Link>
          </>
        )}
      </p>
    );
  };

  const renderMainContent = () => (
    <div className="flex justify-between flex-col lg:flex-row lg:gap-10 w-full mt-5 max-sm:mt-10 items-center">
      {lang === "ar" ? (
        <>
        <div className="mt-10 lg:mt-0 lg:w-2/5 w-full" dir="rtl">
  {poi?.ar_blurb && (
    <p 
      className="lg:text-4xl text-xl italic"
      dangerouslySetInnerHTML={{ 
        __html: `<span class="override-htmlb">${poi?.ar_blurb || ""}</span>` 
      }} 
    />
  )}
  {poi?.ar_shortDescription && (
    <div 
      className="mt-3 text-[20px] max-sm:text-[13px] leading-6 max-sm:leading-5"
      dangerouslySetInnerHTML={{
        __html: `<span class="override-html">${poi.ar_shortDescription}</span>`,
      }} 
    />
  )}
</div>
<div className="lg:w-[793px] max-sm:w-[370px]">
  {images?.length > 0 && <Slider images={images} />}
</div>
        </>
      ) : (
        <>
          <div className="lg:w-[793px] max-sm:w-[370px]">
            {images?.length > 0 && <Slider images={images} />}
          </div>
          {poi && (
            <div className="mt-10 lg:mt-0 max-sm:text-center lg:w-1/2 w-full">
              {poi?.blurb && (
                <p className="lg:text-4xl text-xl italic"
                dangerouslySetInnerHTML={{ __html: `<span class="override-htmlb">${poi?.blurb ? poi?.blurb :""}</span>` }} />
              )}
              {poi?.shortDescription && (
                <div className="mt-3 text-[20px] max-sm:text-[13px] leading-6 max-sm:leading-5"
                dangerouslySetInnerHTML={{ __html: `<span class="override-html">${poi?.shortDescription ? poi?.shortDescription:""}</span>` }} />
              )}
            </div>
          )}
        </>
      )}
    </div>
  );

  const renderTags = () => (
    <div className={`flex flex-wrap lg:gap-3 mt-3 max-sm:gap-2 ${lang === "ar" ? "flex-row-reverse" : ""}`}>
      {(lang === "ar" ? poi?.ar_tags : poi?.tags)?.map((tag, index) => (
        <div className="border text-[15px] border-[#A5A5A5] px-4 rounded-md" key={index}>
          {tag}
        </div>
      ))}
    </div>
  );

  const renderTips = () => {
    const tips = lang === "ar" ? poi?.ar_tips : poi?.tips;
    if (!tips?.length) return null;

    return (
      <div className="lg:mt-5 max-sm:mt-[30px] font-semibold text-[25px] max-sm:text-[16px]" 
           dir={lang === "ar" ? "rtl" : "ltr"}>
        {lang === "ar" ? "نصائح هامة" : "Important Tips"}
        <div className="gap-5 lg:mt-5 max-sm:mt-2 max-sm:gap-2">
          {tips.map((tip, key) => (
            <div key={key} className={`flex flex-col gap-2 ${lang === "ar" ? "text-right" : "text-left"}`} 
                 dir={lang === "ar" ? "rtl" : "ltr"}>
              <div className="flex items-start gap-2">
                <span className="text-lg mb-2">•</span>
                <p className="text-[18px] mt-1 max-sm:mt-2 max-sm:text-[14px] font-medium">{tip}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderAddress = () => (
    <div className="lg:flex lg:justify-between w-full mt-5 max-sm:mt-10">
      <div className="lg:w-[70%] max-sm:w-[60%] max-sm:hidden">
        <p className="font-semibold text-[25px] max-sm:text-[16px]">
          {lang === "ar" ? "عنوان" : "Address"}
        </p>
        <p className="lg:text-[20px] max-sm:text-[16px] mt-3 max-sm:mt-3 text-[#454545]">
          {lang === "ar" ? poi?.ar_address : poi?.address}
          {poi?.latitude && poi?.longitude && (
            <a
              href={`https://www.google.com/maps?q=${poi.latitude},${poi.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline ml-5"
            >
              {lang === "ar" ? "زيارة" : "Visit"}
            </a>
          )}
        </p>
      </div>
    </div>
  );

  return (
    <>
      <Helmet>
        <title>{poi?.[lang === "ar" ? "ar_title" : "title"]}</title>
        {/* <link rel="canonical" href={window.location.href} /> */}
        <meta name="description" content={poi?.[lang === "ar" ? "ar_shortDescription" : "shortDescription"]} />
      </Helmet>

      <div className="px-5 lg:px-20 lg:mt-5 max-sm:mt-5">
        <div className={`${lang === "ar" ? "text-right" : "text-left"}`}>
          <h1 className="lg:text-[70px] max-sm:text-[25px] font-medium" style={{ fontFamily: "inter" }}>
            {poi?.[lang === "ar" ? "ar_title" : "title"]}
          </h1>
          {renderLocationLinks()}
        </div>

        {renderTags()}
        {renderMainContent()}

        <div className="mt-5">
          <Description
            description={poi?.description}
            ar_description={poi?.ar_description}
            language={lang}
          />
        </div>

        {(poi?.thingsToKnow?.length > 0 || poi?.ar_thingsToKnow?.length > 0) && (
          <div className="mt-5 max-sm:mt-8">
            <div className="font-semibold text-[25px] max-sm:text-[16px]">
              {lang === "ar" ? `يفكر في معرفة ${poi?.[lang === "ar" ? "ar_title" : "title"]}` : `Things to Know about ${poi?.[lang === "ar" ? "ar_title" : "title"]}`}
            </div>
            <AccordionUsage
              qa={lang === "ar" ? poi?.ar_thingsToKnow : poi?.thingsToKnow}
              poiName={poi?.[lang === "ar" ? "ar_title" : "title"]}
              language={lang}
              currency={currency}
            />
          </div>
        )}

        <div className="lg:hidden max-sm:w-full mt-5" style={{ borderBottom: "2px solid gray" }} />
        {renderTips()}
        {renderAddress()}
      </div>
{/* render Pois of poi  */}
   <div dir={language == "ar" ? "rtl" : "ltr"}
          className=""
        >
          {/* {load === true ? ( */}
          <div className="lg:py-2 ">
          <div
  className={`flex ${
    language === "ar" ? "items-end" : "items-end"
  } justify-between flex-wrap gap-4 ${
    language === "ar" ? "lg:mr-5 max-sm:me-3" : "lg:px-20 max-sm:px-4"
  } mt-32 max-sm:mt-10`}
>
  <div className="flex flex-col gap-1">
    <p className="text-[25px] max-sm:text-[16px] font-light">
      {language === "ar" ? "استكشاف" : "Exploring"}
    </p>
    <p
      className="lg:text-[40px] max-sm:text-[20px] font-bold text-[#5B27D5]"
    >
      {language === "ar"
        ? `${poi?.stateData?.ar_name}'s جمال`
        : `${poi?.stateData?.name}'s Beauty`}
    </p>
  </div>
<br/>
  <div className="lg:w-[40%] max-sm:w-[40%] border-b border-black" />

  <div
    className={`${
      language === "ar"
        ? "flex flex-row-reverse max-sm:justify-end"
        : "flex max-sm:justify-start"
    } w-full lg:w-auto`}
  >
    <button
      onClick={handelExploreMore}
      className="border-2 border-black rounded-full font-semibold max-sm:text-[14px] max-sm:px-4 max-sm:py-1 px-7 py-1 hover:bg-[#9747FF] hover:border-white hover:text-white"
    >
      {language === "ar" ? "اكتشف المزيد" : "Explore More"}
      <ChevronRightIcon sx={{ fontSize: "18px" }} />
    </button>
  </div>
</div>


            <div
  className={`lg:w-[100%] max-sm:w-[100%] bg-gradient-to-b from-white via-[#f4f1cf] to-white flex ${language === "en" ? "lg:px-20 max-sm:px-5" : "lg:px-20 max-sm:px-5"
    }  lg:gap-10 max-sm:-space-x-5 overflow-y-hidden overscroll-x-contain overflow-x-scroll lg:mt-10 max-sm:mt-6 `}
>
  {poi?.pois?.length > 0 ? (
    poi?.pois?.map((i) => {
      const city2 = i?.cityData?.name?.toLocaleLowerCase().replace(/\s+/g, '-');
      const url = `${i.slug}-${i?.cityData?.name}-${i?.countryData?.name}-poi-${i._id}`;
      const url2 = url.toLowerCase().replace(/\s+/g, '-');
      const image = i.images[0];
      const isArabic = language == "ar";
      const navigateUrl = isArabic
        ? `/ar/place/${city2}/${url2}`
        : `/en/place/${city2}/${url2}`;
      const title = isArabic ? i.ar_title : i.title;
      const stateName = isArabic ? i?.stateData?.ar_name : i?.stateData?.name;
      const description = isArabic
        ? truncateText(i.ar_shortDescription, 130)
        : truncateText(i.shortDescription, 130);

      return (
       <Link
  key={i._id}
  to={navigateUrl}
  className="lg:w-[404px] max-sm:w-[90%] flex-none mb-5 cursor-pointer"
  onClick={(e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
    window.location.href = navigateUrl; // This will force full page reload
  }}
>
          <div>
            <img
              loading="lazy"
              src={image}
              alt={`${title} image`}
              className="lg:w-[404px] lg:h-[280px] max-sm:w-[90%] max-sm:h-[200px] rounded-md hover:shadow-xl"
            />
          </div>
          <div className="py-4">
            <p className="text-[20px] max-sm:text-[15px]">
              <b className="text-[22px] max-sm:text-[20px]">{title}, </b>
              {stateName}
            </p>
            <div
              className="lg:mt-5 max-sm:mt-3 max-sm:w-[90%] text-[17px] max-sm:text-[10px] lg:leading-5 max-sm:leading-3"
              dangerouslySetInnerHTML={{
                __html: `<span class="override-html">${truncateText(
                  description,
                  language === "ar" ? 10 : 30
                )}</span>`,
              }}
            ></div>
          </div>
        </Link>
      );
    })
  ) : (
    <p className="py-5">
      {language == "ar"
        ? "لا توجد نقاط اهتمام متاحة."
        : "No Points of Interest available."}
    </p>
  )}
</div>
          </div>
          {/* //     ) : (
      //       <div className="flex  lg:ms-20 max-sm:ms-5 lg:gap-20 max-sm:gap-5  overscroll-x-conatin overflow-x-scroll mt-5">

      //         <CardList2 />
      //         <CardList2 />
      //         <CardList2 />
      //         <CardList2 />
      //         <CardList2 />

      //       </div>
      //  )}  */}
        </div>


<div className='mt-5'>
  <LatestBlogs blogsData={poi?.blogs} language={language}/>
</div>

    </>
  );
}

export default Poi;